'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".ItemImage-module_itemImageListItem__sqpFy{display:inline-block}.ItemImage-module_itemImageListItem__sqpFy+.ItemImage-module_itemImageListItem__sqpFy{margin-left:.5rem}";
var styles = {"itemImageListItem":"ItemImage-module_itemImageListItem__sqpFy"};
styleInject["default"](css_248z, 'cd96ea7c-7e35-4461-a98f-f41f8ba6facc');

exports["default"] = styles;
